<template>
    <span style="max-height:400px; overflow-y:auto; width:100%;">
        
        <CRow>
            <CCol col="7">
                <CInput
                    label="Buscar:"
                    style="margin-top:0"
                    v-model="filtroTexto"
                    type="text"
                    horizontal
                />
            </CCol>
            <CCol sm="1" md="1" lg="1">
                <CIcon class="imgr mt-2"
                    v-show="loadingEmpresas"
                    name="cilLoopCircular"
                    v-tippy="getBaseTippy(`Comprobando sus Empresas`)"
                />
            </CCol>
            <CCol>
                <CPagination
                    v-show="empresasFiltradas.length > 5"
                    class="mt-1"
                    size="sm"
                    :active-page.sync="paginaActual"
                    :pages="$vs.getLength(empresasFiltradas, 5)"
                    responsive
                    align="end"
                />
            </CCol>
        </CRow>
        <transition name="slide-fade" mode="out-in">
            <CRow style="max-height: 300px; overflow-y: auto;" :key="paginaActual">
                <CCol>
                    <div v-for="(empresa, index) in $vs.getPage(empresasFiltradas, paginaActual, 5)">
                        
                        <CCard class="mb-2">
                            <CCardHeader>
                                <div class="card-header-actions" v-if="('msjActualizacion' in empresa) ?  empresa.msjActualizacion.length > 0 : false">
                                    <CLink class="card-header-action btn-minimize" @click="empresa.mostrarMas = !empresa.mostrarMas">
                                        <CIcon v-show="empresa.mostrarMas" :content="$options.freeSet.cilChevronTop" />
                                        <CIcon v-show="!empresa.mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                                    </CLink>
                                </div>
                                <CRow>
                                    <CCol sm="9" md="9" lg="9">
                                        <span class="font-weight-bold" style="font-size: 0.8rem;">
                                            (<span>{{ empresa.codEmpresa }}</span>) 
                                            <span >{{ empresa.nombreEmpresa }}</span>
                                            - <span>{{ $utils.formatearRut(empresa.rutEmpresa) }}</span>
                                        </span>    
                                        <span class="ml-3 fecha-info" :class="$utils.colorDiferenciaFecha(empresa.ultimaActualizacion)"
                                        v-tippy="getBaseTippy(`Fecha última Sincronización`)">
                                            {{formatearFecha(empresa.ultimaActualizacion)}}
                                            ({{ $utils.calcularDifecenciaDias(empresa.ultimaActualizacion) }})
                                        </span>
                                    
                                    </CCol>
                                    <CCol sm="3" md="3" lg="3">
                                        <span>
                                            <span class="desplegarEmpresas ml-2 pi pi-sync pi-spin" v-if="empresa.actualizando"
                                                v-tippy="getBaseTippy(`Sincronizando...`)">
                                            </span>
                                            <CButton 
                                                v-else
                                                :disabled="empresa.actualizando" @click="actualizar(empresa)"
                                                class="btnPrincipalVapp"
                                                style="min-height: auto; font-size: 0.6rem; font-weight: normal;"
                                                size="sm"
                                                variant="ghost">
                                                <span class="mr-1 pi pi-sync" :class="empresa.actualizando?'pi-spin':''"></span>
                                                <span v-show="$mq !== 'mobile'">Sincorizar</span>
                                            </CButton>
                                        </span>
                                    </CCol>
                                </CRow>
                                <!--<span class="font-weight-bold" style="font-size: 0.8rem;">(<span>{{ empresa.codEmpresa }}</span>) 
                                    <span >{{ empresa.nombreEmpresa }}</span>
                                    - <span >{{ $utils.formatearRut(empresa.rutEmpresa) }}</span>
                                        
                                
                                </span>
                                
                                <span class="ml-3 fecha-info" v-tippy="getBaseTippy(`Fecha última Sincronización`)">{{formatearFecha(empresa.ultimaActualizacion)}}</span>
                                
                                <span>
                                    <span class="desplegarEmpresas ml-2 pi pi-sync pi-spin float-right" v-if="empresa.actualizando"
                                        v-tippy="getBaseTippy(`Sincronizando...`)">
                                    </span>
                                    <CButton 
                                        v-else
                                        :disabled="empresa.actualizando" @click="actualizar(empresa)"
                                        class="btnPrincipalVapp float-right"
                                        style="min-height: auto; font-size: 0.6rem; font-weight: normal;"
                                        size="sm"
                                        variant="ghost">
                                        <span class="mr-1 pi pi-sync" :class="empresa.actualizando?'pi-spin':''"></span>Sincorizar
                                    </CButton>
                                </span>-->

                            </CCardHeader>
                            <CCollapse :show="empresa.mostrarMas" :duration="400">
                                <CCardBody style="max-height: 260px; overflow-y: auto;">
                                    <span v-if="('msjActualizacion' in empresa) ?  empresa.msjActualizacion.length > 0 : false">
                                        <span>Mensajes Sincronización:</span> <span>{{ empresa.msjActualizacionGeneral }}</span>
                                        <CAlert show  v-for="(msj, index) in empresa.msjActualizacion[0].mensajes" :key="msj.id || msj.name || index" color="secondary">{{ msj.mensaje }}</CAlert>
                                    </span>
                                </CCardBody>
                            </CCollapse>

                        </CCard>
                        <!--<CRow class="mt-2">
                            <CCol sm="4" md="2" lg="2">
                                <span>({{ empresa.codEmpresa }}) </span><span>{{ empresa.nombreEmpresa }}</span>
                            </CCol>
                            <CCol sm="3" md="2" lg="2">
                                <span class="desplegarEmpresas ml-2 pi pi-sync pi-spin" v-if="empresa.actualizando"
                                    v-tippy="getBaseTippy(`Actualizando...`)">
                                </span>
                                <CButton 
                                    v-else
                                    :disabled="empresa.actualizando" @click="actualizar(empresa)"
                                    class="btnPrincipalVapp"
                                    size="sm"
                                    variant="ghost">
                                    <span class="mr-1 pi pi-sync" :class="empresa.actualizando?'pi-spin':''"></span>Actualizar
                                </CButton>
                            </CCol>
                            <CCol>
                                <span v-if="('msjActualizacion' in empresa) ?  empresa.msjActualizacion.length > 0 : false">
                                    <span>Mensajes Actualización:</span>
                                    <CAlert show  v-for="(msj, index) in empresa.msjActualizacion[0].mensajes" color="secondary">{{ msj.mensaje }}</CAlert>
                                </span>
                            </CCol>
                        </CRow>
                        
                    <hr v-show="index != empresas.length-1">-->
                    </div>
                    
                </CCol>
            </CRow>
        

        </transition>
        <!--<CRow v-for="(empresa, index) in empresas">
            <CCol>CodEmpresa: </CCol>
            <CCol>{{empresa}}</CCol>
        </CRow>-->
    </span>
    
  
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import cons from "@/const";
    import axios from "axios";
    import apiUrls from '@/views/utils/apiUrls'

    import { freeSet } from "@coreui/icons";
    import * as util from '@/views/utils/utilsFunctions'

    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";

    
    import Pagination from 'vue-pagination-2';

export default {
    name: "ActualizarEmpresas",
    freeSet,
    props: {
        empresas: Array,
        tipoBd: String,
        loadingEmpresas: Boolean
    },
    components: {
        Pagination
    },
    data() {
        return {
            
            urlBase: cons.port+"://" + cons.ipServer,
            tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
            tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
            idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,

            
            filtroTexto: "",

            paginaActual: 1,
        };
    },
    created: function () {
    },
    beforeMount() {
    },
    computed: {
        empresasFiltradas() {
            if(this.filtroTexto == '') {
                return this.empresas;
            }
            return this.empresas.filter(item => 
                this.validarCampo(item.rutEmpresa) ||
                this.validarCampo(this.$utils.formatearRut(item.rutEmpresa)) ||
                this.validarCampo(item.nombreEmpresa) ||
                this.validarCampo(item.codEmpresa)
            );
        }
    },
    methods: {
        /*filtrarCliente: function(){
            if(this.filtroTexto == ''){
                return this.empresas
            } else {
                let filtro = this.empresas.filter(item => 
                    this.validarCampo(item.rutEmpresa) ||
                    this.validarCampo(this.$utils.formatearRut(item.rutEmpresa)) ||
                    this.validarCampo(item.nombreEmpresa) ||
                    this.validarCampo(item.codEmpresa)
                )
                return filtro
            }


        },*/
        validarCampo: function(campoValidar){
            if (!this.filtroTexto || !campoValidar) {
                return false
            }
            return campoValidar.toLowerCase().includes(this.filtroTexto.toLowerCase())
        },

        actualizar2: function(emp){
            this.$set(emp, "actualizando", true)
            this.$set(emp, "msjActualizacion", [])

            console.log("asdasd", `http://${cons.ipServer}/ws/some_path/`)
            this.socket = new WebSocket(`ws://${cons.ipServer}/ws/some_path/`);
            console.log("this.socket", this.socket)
            // Evento: conexión exitosa
            this.socket.onopen = () => {
                this.connectionStatus = "Conectado al WebSocket";
                console.log("Conexión exitosa con el WebSocket");
            };

            // Evento: mensaje recibido
            this.socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                console.log("Mensaje recibido del servidor:", data);
                this.respuesta = data;
                this.$set(emp, "actualizando", false)
            };

            // Evento: error en la conexión
            this.socket.onerror = (error) => {
                console.error("Error en el WebSocket:", error);
                this.connectionStatus = "Error en la conexión";
                this.$set(emp, "actualizando", false)
            };

            // Evento: desconexión
            this.socket.onclose = () => {
                this.connectionStatus = "Desconectado del WebSocket";
                console.log("WebSocket desconectado");
                this.$set(emp, "actualizando", false)
            };
        },

        actualizar: function(emp){
            this.$set(emp, "actualizando", true)
            this.$set(emp, "msjActualizacion", [])
            this.$set(emp, "msjActualizacionGeneral", '')

            const axiosSource = axios.CancelToken.source();
            this.rqstActualizarEmpresas = { cancel: axiosSource.cancel, msg: "Cargando..." };
            var url = this.urlBase + apiUrls.general.actualizarBd

            axios({
                method: "POST", 
                "url": url,
                cancelToken: axiosSource.token,
                "data": {
                    "info": {
                        "actualizarTodoCliente": false,
                        "idCliente": this.idCliente,
                        "empresasActualizar": [emp],
                        "tipoBd": this.tipoBd
                    }
                },
                "headers": {
                    'Authorization': this.tokenLogin
                }
            }
            ).then(result => {
                this.$set(emp, "msjActualizacion", result.data.mensajesEmpresa)
                
                this.$set(emp, "msjActualizacionGeneral", result.data.mensajeGeneral)
                this.$set(emp, "ultimaActualizacion", result.data.ultfechaActualizacion)
                this.$emit("refreshFechaActualizacion")
                
            }, error => {
                // mensaje = "Ups, Tuvimos un problema al actualizar, si el problema persiste contacte con nuestro soporte, Gracias."
                
                this.$set(emp, "msjActualizacion", [{"mensajes": [{"mensaje": error.response.data.mensajeGeneral}]}])
            })
            .finally(() => {
                this.$set(emp, "actualizando", false)
            });
        },
        
        formatearFecha: function(fecha){
            return util.formatFechaNormal(fecha)
        },
    },
};
</script>

<style scoped>
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateY(20px); /* Cambia el deslizamiento a vertical */
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.highlight {
  background-color: yellow;
  font-weight: bold;
  color: black;
}

.fecha-info {
        vertical-align: middle;
      
      font-size: 0.6rem; /* Tamaño del texto */
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter {
  background-color: #d9edf7; /* Azul claro al entrar */
  color: #31708f; /* Texto más oscuro al entrar */
  transform: scale(1.1);
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>